import { render, staticRenderFns } from "./patient_details.vue?vue&type=template&id=088e62a3&scoped=true&"
import script from "./patient_details.vue?vue&type=script&lang=js&"
export * from "./patient_details.vue?vue&type=script&lang=js&"
import style0 from "./patient_details.vue?vue&type=style&index=0&id=088e62a3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "088e62a3",
  null
  
)

export default component.exports